import React from "react";
import PropTypes from "prop-types";
import { tableSkeleton } from "../../constant/helper/helper";

const DeviceList = ({
  deviceList,
  deviceLoading,
  onDeleteDevice
}) => {
  if (deviceLoading) {
    return <tr>{tableSkeleton(12)}</tr>;
  } else if (deviceList.length === 0) {
    return (
      <tr>
        <td>
          <span className=""> No Record Found</span>
        </td>
      </tr>
    );
  } else if (
    typeof deviceList !== "undefined" &&
    deviceList !== null &&
    deviceList.length > 0
  ) {
    return deviceList.map((deviceDetail, index) => (
      <tr key={index}>
        <td>
          <span className="">{index + 1}</span>
        </td>
        <td>
          <span className="">
            {deviceDetail?.locationId?.locationName}
          </span>
        </td>
        <td>
          <span className="">
            {deviceDetail?.locationId?.locationType}
          </span>
        </td>
        <td>
          <span className="">
            {deviceDetail?.locationId?.locationCode}
          </span>
        </td>
        <td>
          <span className="">{deviceDetail?.workerName}</span>
        </td>
        <td>
          <span className="">{deviceDetail?.workerId}</span>
        </td>
        <td>
          <span className="">{deviceDetail?.workerNumber}</span>
        </td>
        <td>
          <span className="">{deviceDetail?.deviceName}</span>
        </td>
        <td>
          <span className="">{deviceDetail?.modelName}</span>
        </td>
        <td>
          <span className="">
            {deviceDetail?.createdBy?.workerFirstName +
              " " +
              deviceDetail?.createdBy?.workerSurname}
          </span>
        </td>
        <td>
          <span className="">
            {new Date(deviceDetail?.createdAt).toLocaleDateString()}
          </span>
        </td>
        <td>
          <span className="">{deviceDetail?.createdByIp}</span>
        </td>
        <td className="text-center">
          <button
            className="button "
            onClick={() => onDeleteDevice(deviceDetail)}
          >
            Delete
          </button>
        </td>
      </tr>
    ));
  }
};

DeviceList.propTypes = {
  deviceList: PropTypes.array.isRequired,
  deviceLoading: PropTypes.bool.isRequired,
  onDeleteDevice: PropTypes.func.isRequired
};

export default DeviceList;
